<template>
  <div>
      <transition name="fadeburger">
         <div class="address-box" v-if="showBoxes">
             <div class="inner">

          
                  <div class="checkbox" @click="getCheckBoxes($event)">
                      <el-checkbox v-model="mainAddressChecked" @change="changeMain($event)" :checked="true" v-if="item.main_adress === 1"></el-checkbox>
                      <el-checkbox v-model="mainAddressChecked" @change="changeMain($event)" :checked="false" v-if="item.main_adress === 0" ></el-checkbox>
                  
                  </div>
                  <div class="text-box">
                    <span class="f-21 bold-italic">{{ item.name }}</span>
                    <span class="f-16 light-italic">{{getCityTranslate(item.city)}}</span>
                    <span class="f-16 light-italic">{{ item.street }}</span>
                    <span class="f-16 light-italic">{{$fn.tr('ტელეფონი')}}: {{ item.phone }}</span>
                    <div class="changes-box">
                      <span class="f-13 light-italic" @click="dropItLikeHot">{{$fn.tr('ცვლილების გაკეთება')}}</span>
                      <span class="f-13 light-italic" @click="removeAddress">{{$fn.tr('წაშლა')}}</span>
                    </div>
                  </div>
                </div>
                   <slide-up-down
          :active="active"
          :duration="500"
          class="i-dropdown-content"
        >


                <el-form
                :model="formaddress"
                :rules="addressrules"
                ref="formaddress"
                class="cabinet-form"
                >      

                <svg class="line-divider" xmlns="http://www.w3.org/2000/svg" width="635" height="1" viewBox="0 0 635 1">
  <path id="Path_3851" data-name="Path 3851" d="M40.97,7.1c182.65-.392,367.635.035,551.148-.215,46.517-.063,73.631-.849,10.987-.763-183.559.251-368.153-.178-551.147.215C6.49,6.431-21.423,7.231,40.97,7.1Z" transform="translate(-4.75 -6.112)" fill="#3a5aa7" opacity="0.2"/>
</svg>


                  <!-- <h2 class="f-21 bold-italic">ახალი მისამართი</h2> -->

                        <el-form-item  class="input-wrapper" prop="name">
           <el-input :placeholder="$fn.tr('სახელი და გვარი')" type="სახელი და გვარი" v-model="formaddress.name"></el-input>
           </el-form-item>

            <el-form-item  class="input-wrapper" prop="phone">
         <el-input :placeholder="$fn.tr('ტელ.ნომერი')" type="age" v-model="formaddress.phone"></el-input>
         </el-form-item >

 <el-form-item  class="input-wrapper" prop="city">
           <!-- <el-input :placeholder="$fn.tr('ქალაქი')" type="text" v-model="formaddress.city"></el-input> -->
                <el-select v-model="formaddress.city" :placeholder="$fn.tr('ქალაქი')" :label="getCityTranslate(item.city)" :value="item.city" :popper-append-to-body="false">
                <el-option
                v-for="item in city_list"
                :key="item.id"
                :label="item.title"
                :value="item.slug"
                
                >
                </el-option>
            </el-select>
         </el-form-item >


      <el-form-item  class="input-wrapper" prop="address">
         
           <el-input :placeholder="$fn.tr('მისამართი')" type="text" v-model="formaddress.address"></el-input>
      </el-form-item >



              
         
      

 
     
         
     

    </el-form>


              <div class="send-btn" @click="changeAddress();">
          <span class="f-21">{{$fn.tr('შენახვა')}}</span>
      </div>

        </slide-up-down>
                </div>
                </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    props: ['item', 'id'],
    data(){
         var checkAddress = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('გთხოვთ შეავსოთ ველი'));
        } 
         else {
        //  console.log("correct")
          callback();
        }
      };
        return{
            active: false,
            addressesArr: {},
            showBoxes: true,
            mainAddressChecked: 0,
            deleteAddress: false,

              formaddress: {
          address: this.item.street,
          name: this.item.name,
          phone: this.item.phone,
          city: this.item.city,
      },
      addressrules: {
      address: [
          { required: true, validator: checkAddress, trigger: this.changeAddress }
        ],
         city: [
          { required: true, validator: checkAddress, trigger: this.changeAddress }
        ],
         name: [
          { required: true, validator: checkAddress, trigger: this.changeAddress }
        ],

        phone: [
          { required: true, validator: checkAddress, trigger: this.changeAddress }
        ],
      }
        }
    },
computed: {
  ...mapGetters({
            addresses: "main/returnUser"
        }),

           city_list(){
        return this.$store.state.main.indx.terms.customer_cities;
      },
},

mounted(){
    this.addressArr = this.addresses.address;
  //  console.log(this.addressArr)
},

methods: {
  getCityTranslate(item){
    let cc = this.$store.state.main.indx.terms.customer_cities;
    cc = cc.filter(c => c.slug == item );
  
 
    return cc[0].title;
  },
    async removeAddress(){
        this.deleteAddress = false;
          let data = {};
              data.name = null;
            data.phone = null;
            data.city = null;
            data.street = null;
            data.house = null;
            data.entrance = null;
            data.floor = null;
            data.main_adress = null;
            data.id = this.id;
            data.deleteAdress = this.deleteAddress;

         let tmp =  await this.$fn.postData('user/deleteaddress',{data:data, token:localStorage.userToken});

        //  console.log(tmp)

         
       this.$store.commit("main/changeAddress", tmp.data.success);

         this.$emit('clicked', null)
        this.$emit('clickedMainAddress', null)
    },

     async changeMain(e){
         if(this.mainAddressChecked === 0){
             this.mainAddressChecked === 1;
         } else if (this.mainAddressChecked === 1){
             this.mainAddressChecked === 0
         }
        
          let data = {};
            data.name = this.item.name;
            data.phone = this.item.phone;
            data.city = this.item.city;
            data.street = this.item.street;
            data.house = this.item.house;
            data.entrance = this.item.entrance;
            data.floor = this.item.floor;
           
            data.main_adress = this.mainAddressChecked;
            data.id = this.id;
           

         let tmp =  await this.$fn.postData('user/editaddress',{data:data, token:localStorage.userToken});

        //  console.log(tmp)

         
       this.$store.commit("main/changeAddress", tmp.data.success);
        // console.log(this.mainAddressChecked)
         this.$emit('clicked', null)
        this.$emit('clickedMainAddress', null)
      

    },

    async dropItLikeHot(){
        this.active = !this.active;
          this.$emit('dropped', null);

           let data = {};
            data.name = this.item.name;
            data.phone = this.item.phone;
            data.city = this.item.city;
            data.street = this.item.street;
            data.house = this.item.house;
            data.entrance = this.item.entrance;
            data.floor = this.item.floor;
           
            data.main_adress = this.mainAddressChecked;
            data.id = this.id;
           

         let tmp =  await this.$fn.postData('user/editaddress',{data:data, token:localStorage.userToken});

        //  console.log(tmp)

         
       this.$store.commit("main/changeAddress", tmp.data.success);
        // console.log(this.mainAddressChecked)
    },
    getCheckBoxes(e){
        let target = e.currentTarget.parentElement.parentElement.parentElement;
        //   console.log(target.querySelector())
           let boxes = target.querySelectorAll(".address-box");
           boxes.forEach(box => {
               if(box.classList.contains(".is-checked") ){
                  
               }
           })
    },

   async changeAddress(){
          this.$refs.formaddress.validate((valid) => {
          if (valid) {
          //  console.log('submitted')
          } else {
          //  console.log('error submit!!');
            return false;
          }
        });


         this.active = !this.active;
          this.$emit('dropped', null);

           let data = {};
            data.name = this.formaddress.name;
            data.phone = this.formaddress.phone;
            data.city = this.formaddress.city;
            data.street = this.formaddress.address;
            data.house = this.item.house;
            data.entrance = this.item.entrance;
            data.floor = this.item.floor;
           
            data.main_adress = this.mainAddressChecked;
            data.id = this.id;
           

         let tmp =  await this.$fn.postData('user/editaddress',{data:data, token:localStorage.userToken});

        //  console.log(tmp)

         
       this.$store.commit("main/changeAddress", tmp.data.success);
                 this.$emit('clicked', null)

    }
}

}
</script>

<style lang="scss">
.cabinet .el-select .el-input.is-focus .el-input__inner{
  border-color: #044B30;
}
</style>